import * as React from 'react'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useData } from './hooks'

type Props = {
  onCancelClick: () => void
}

export function ActivityFormActions(props: Props) {
  const { onCancelClick } = props
  const { disableSave } = useData()

  return (
    <Stack direction="row" spacing={1} justifyContent="end" pt={2}>
      <Button fullWidth size="small" onClick={onCancelClick}>
        <Typography minWidth={110}>Cancel</Typography>
      </Button>
      <Button
        fullWidth
        size="small"
        variant="contained"
        type="submit"
        disabled={disableSave}
      >
        <Typography minWidth={110}>Save</Typography>
      </Button>
    </Stack>
  )
}
